import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./Admin/Auth/Login";
import Dashboard from "./Admin/Component/Dashboard";
import "./App.css";
import NavBar from "./Admin/navbar.js";
import SideNavBar from "./Admin/sidebar.js";
import Form from "./Admin/form.js";
import ViewForm from "./Admin/Component/Forms/Viewform";
import ViewStaff from "./Admin/Component/Staffs/ViewStaff";
import Designation from "./Admin/Component/Staffs/Designation";
import ViewSchool from "./Admin/Component/School/ViewSchool";
import ViewSubscription from "./Admin/Component/Subscription/ViewSubscription.js";
import ViewInActiveSchool from "./Admin/Component/School/ViewInActiveSchool.js";
import DayBookExport from "./Admin/excel.js";
import ViewPackage from "./Admin/Component/Package/Package.js";
import ViewModule from "./Admin/Component/Package/Modules.js";
const RequireAuth = ({ children }) => {
  const token = localStorage.getItem("authToken");
  const location = useLocation();
 //mndfhd
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

const AppContent = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const location = useLocation(); 

  const pathToTitle = {
    "/": "Dashboard",
    "/dashboard": "Dashboard",
    "/view-form": "View Form",
    "/view-staff": "View Staff",
    "/designation": "Designation",
    "/view-school": "View School",
    "/view-in-active-school": "View InActive School",
    "/view-subscription": "View Subscription",
    "/view-package": "View Package",
    "/view-module": "View Module",
  };

  const OpenPage = pathToTitle[location.pathname] || "Dashboard";

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <SideNavBar
        isCollapsed={isSidebarCollapsed}
        toggleSidebar={toggleSidebar}
        setIsCollapsed={setIsSidebarCollapsed}
        setOpenPage={OpenPage}
      />

      <div
        className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 ${
          isSidebarCollapsed ? "ml-[3.5rem]" : "ml-[13.9rem]"
        }`}
      >
        <NavBar title={OpenPage} />

        <div className="flex-1 overflow-auto bg-gray-100">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/view-form" element={<ViewForm />} />
            <Route path="/view-staff" element={<ViewStaff />} />
            <Route path="/designation" element={<Designation />} />
            <Route path="/view-school" element={<ViewSchool />} />
            <Route path="/view-in-active-school" element={<ViewInActiveSchool />} />
            <Route path="/view-subscription" element={<ViewSubscription />} />
            <Route path="/view-package" element={<ViewPackage />} />
            <Route path="/view-module" element={<ViewModule />} />
            
            

          </Routes>
        </div>
      </div>
    </div>
  );
};

const App = () => (
  <BrowserRouter>
    <Routes>
      {/* Login Routes */}
      <Route path="/login" element={<Login />} />

      {/* After LogIn Routes */}
      <Route
        path="*"
        element={
          <RequireAuth>
            <AppContent />
          </RequireAuth>
        }
      />
      <Route path="/add-form" element={<Form />} />
      <Route path="/excel" element={<DayBookExport />} />
    </Routes>

    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
  </BrowserRouter>
);

export default App;
